import { render, staticRenderFns } from "./MachineRenewal.vue?vue&type=template&id=2b59c25c&scoped=true&"
import script from "./MachineRenewal.vue?vue&type=script&lang=js&"
export * from "./MachineRenewal.vue?vue&type=script&lang=js&"
import style0 from "./MachineRenewal.vue?vue&type=style&index=0&id=2b59c25c&scoped=true&lang=scss&"
import style1 from "./MachineRenewal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59c25c",
  null
  
)

export default component.exports